import { EVENT } from '../../common/events/listEvents';
import memberServices from "../../services/MemberService"

export default class ErrorReportingTool {

    static actionOnData(errorData, otherStack) {
        let goToPageError = false;
        console.error('Error reported. :)');
        console.error('error', errorData);
        console.error('otherErrorStack', otherStack);
        
        if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
            //window.location.href = '/en/error';
           

        } else {
            goToPageError = false;
           
        }
        if(goToPageError){
            sessionStorage.setItem('lastSysErrorID', new Date().getTime());
            sessionStorage.setItem('lastSysErrorInfoStack', JSON.stringify(errorData));
            sessionStorage.setItem('lastSysErrorStack', otherStack);
            window.location.href = '/en/syserror';
        }
    }

    /**
     * Report error data
     */
    static reportData(errorData) {
        this.actionOnData(errorData, "");

    }

    /**
     * 
     * Report error of function belong React LifeCycle
     */
    static reportReactLifeCycle(info, otherStack) {
        this.actionOnData(info, otherStack);
    }

    static showPopupServiceError(code, message) {
         window.fireEvent(EVENT.API_SERVICE_ERROR);
         sessionStorage.setItem('APIErrorCode', code);
         sessionStorage.setItem('APIErrorMessage', message);
         let errorObject = {
            lastSysErrorID: new Date().getTime(),
            lastSysErrorInfoStack: message,
            lastSysErrorStack :  ''
        }
         memberServices.reportSystemError(errorObject);
    }

}


// WEBPACK FOOTER //
// ./src/app/common/config/ErrorReportingTool.js